export default __webpack_public_path__ + "static/media/9t.c082f704.jpg";